<template>
    <page title="bestlistTitle" :help="help">
        <template #pageContainer>
            <v-row>
                <v-col cols="12" md="12" class="py-1">
                    <v-card>
                        <v-data-table
                            :headers="headers"
                            :items="Entities"
                            item-key="id"
                            class="elevation-1"
                            :items-per-page="400"
                            :loading="loading"
                            :loading-text="$t('text.bestListsLoading')"
                            :server-items-length="Entities.length"
                            hide-default-footer
							:height="WindowSize.y - 380"
                            fixed-header>
                            <template #top>
                                <v-container class="mt-0 pt-0 pb-0 mb-0">
                                    <v-row>
                                        <v-col cols="12" sm="3" lg="2">
                                            <v-btn-toggle dense color="primary">
                                                <v-btn
                                                    color="primary"
                                                    @click="newBestList">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.newBestList`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        add
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
										<v-col cols="12" sm="7" lg="8">
                                            <v-text-field outlined dense
                                                hide-details="auto"
                                                class="mt-0 pt-0"
                                                clearable
                                                v-model="tempQP.freetextSearch"
                                                :label="$t('text.name') +'/'+ $t('text.competitionLocation')"
                                                @keyup.enter.native="search">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="2" lg="2"
											align="right">
                                            <v-btn-toggle dense
                                                color="secondary"
                                                justify="center"
                                                active-class="action-active">
                                                <v-btn
                                                    color="secondary"
                                                    @click="search">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.searchButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        search
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                            <template #[`item.action`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="redirect(item.id)">
                                            <v-icon>
                                                present_to_all
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t(`text.redirectPerfList`) }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="edit(item.id)">
                                            <v-icon>
                                                edit
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.edit`) }}</span>
                                </v-tooltip>
								<v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="exportperflist(item.id)">
                                            <v-icon>
                                                file_download
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t(`text.exportPerfList`) }}</span>
                                </v-tooltip>
                                <!-- <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="deleteBestList(item.id)">
                                            <v-icon>
                                                delete
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.delete`) }}</span>
                                </v-tooltip> -->
                            </template>
                        </v-data-table>

                        <pagination
                            :currentPage="Pagination.currentPage"
                            :totalPages="Pagination.totalPages"
                            :pageSize="queryParameters.pageSize"
                            @current="current"
                            @pageSizeChanged="pageSizeChanged">
                        </pagination>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import config from '../helpers/config';

import Page from '../general/Page.vue';
import Pagination from '../general/Pagination.vue';

import bestListActions from '../store/actions/bestList';
import namespace from '../store/namespace';

class TempBestListQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.freetextSearch = qp.freetextSearch;
		}
	}
}

class BestListQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.freetextSearch = qp.freetextSearch;
			this.pageNumber = qp.pageNumber;
			this.pageSize = qp.pageSize;
		} else {
			this.pageNumber = 1;
			this.pageSize = 10;
			this.freetextSearch = '';
		}
	}

	updateTempData(tempQP) {
		this.freetextSearch = tempQP.freetextSearch;
	}
}


export default {
	name: 'Bestlist',
	components: {
		Page,
		Pagination,
	},
	data() {
		return {
			headers: [
				{
					text: this.$i18n.t('text.headerActions'), align: 'left', value: 'action', sortable: false, width: '140px',
				},
				{
					text: this.$i18n.t('text.headerBestlistName'), align: 'left', value: 'name', sortable: false,
				},
				{
					text: this.$i18n.t('text.headerRegionalRestriction'), align: 'left', value: 'regionalRestrictionName', width: '50%', sortable: false,
				},
			],
			loading: true,
			queryParameters: new BestListQueryParameter(),
			tempQP: new TempBestListQueryParameter(),
			help: [{
				icon: 'present_to_all',
				text: this.$t('text.redirectPerfList'),
			},
			{
				icon: 'edit',
				text: this.$t('text.edit'),
			},
			{
				icon: 'file_download',
				text: this.$t('text.exportPerfList'),
			}],
		};
	},
	async mounted() {
		if (localStorage.getItem('bestListApp')) {
			this.queryParameters = new BestListQueryParameter(JSON.parse(localStorage.getItem('bestListApp')));
			this.tempQP = new TempBestListQueryParameter(this.queryParameters);
		} else {
			localStorage.setItem('bestListApp', JSON.stringify(this.queryParameters));
		}
		await this.loadData();
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.ORGANIZATION, ['ExternalId']),
		...mapGetters(namespace.BESTLIST, ['Links', 'Entities', 'Pagination']),
		config() {
			return config.seltec.perfUrl;
		},
		nonContentPage() {
			return this.Entities.length == 0;
		},
	},
	watch: {
		queryParameters: {
			deep: true,
			handler() {
				localStorage.setItem('bestListApp', JSON.stringify(this.queryParameters));
			},
		},
	},
	methods: {
		...mapActions(namespace.BESTLIST, [
			bestListActions.GET_BEST_LISTS,
			// bestListActions.DELETE_BEST_LIST,
		]),
		async search() {
			this.queryParameters.updateTempData(this.tempQP);
			localStorage.setItem('bestListApp', JSON.stringify(this.queryParameters));
			this.queryParameters.pageNumber = 1;
			await this.loadData();
		},
		async loadData() {
			this.loading = true;
			try {
				const perfListRequest = {
					masterOrgId: this.ExternalId,
					queryParameters: this.queryParameters,
				};

				await this.GET_BEST_LISTS(perfListRequest);
				if (this.nonContentPage) {
					this.queryParameters.pageNumber = this.Pagination.totalPages;
				}
			} finally {
				this.loading = false;
			}
		},
		newBestList() {
			this.$router.push({
				name: 'newbestlist',
			});
		},
		redirect(id) {
			window.open(`${this.config}${id}`, '_blank');
		},
		async edit(id) {
			this.$router.push({
				name: 'updatebestlist',
				params: {
					id,
				},
			});
		},
		async exportperflist(id) {
			this.$router.push({
				name: 'exportbestlist',
				params: {
					id,
				},
			});
		},
		// async deleteBestList(id) {
		// 	// eslint-disable-next-line no-restricted-globals
		// 	const r = confirm(this.$i18n.t('text.deleteRequest'));
		// 	if (r === true) {
		// 		try {
		// 			const link = this.Links.find(x => x.rel === 'delete_best_list');
		// 			if (link) {
		// 				const href = link.href
		// 					.replace('{id}', id);
		// 				await this.DELETE_BEST_LIST({ href });
		// 				this.loadData(this.queryParameters);
		// 			}
		// 		} catch (ex) {
		// 			console.log(ex);
		// 		}
		// 	}
		// },
		async pageSizeChanged(newPageSize) {
			this.queryParameters.pageSize = newPageSize;
			const maxPage = Math.ceil(this.Pagination.totalCount / newPageSize);
			this.queryParameters.pageNumber = maxPage < this.Pagination.currentPage ? maxPage : this.Pagination.currentPage;

			await this.loadData();
		},
		async current(newPage) {
			this.queryParameters.pageNumber = newPage;

			await this.loadData();
		},
	},
};
</script>

<style lang="scss" scoped>

.action-active {
    border-color: rgba(0,0,0,.12) !important;
    color: rgb(255, 255, 255) !important;
    opacity: 0.8 !important;

    &:before {
        opacity: 0 !important;
    }
}
</style>
